export function paymentsReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_PAYMENT":            
        case "UPDATE_PAYMENT":
            let list = Object.assign({}, state);
            list[payload.payment_id] = payload
        
            return list

        case "NEW_PAYMENT_COLLAB":            
            let list2 = Object.assign(payload, state)
            return list2
        case "NEW_PAYMENT_SUPPLIER":            
            let list4 = Object.assign({}, state)
            payload.forEach(element => {
                list4[element.payment_id] = payload
            });
            return list4
        case "DELETE_PAYMENT":            
            let list3 = Object.assign({}, state);
    
            delete list3[payload.payment_id]
            return list3
             
        case "GET_PAYMENTS":

            return payload
    
        default:
            return state;
    }
    
}